import { createContext, useContext } from 'react';

/**
 * Registro dos saves pendentes dos passos do wizard.
 *
 * Cada passo com formulário registra (por chave) uma função que persiste a sua
 * edição ainda não salva; a navegação do wizard dispara todas ANTES de trocar de
 * passo (auto-save — nunca perder trabalho ao clicar em outro passo). Registrar
 * `null` remove a chave (nada pendente). Fora do wizard o registro é um no-op.
 */
export type RegisterFlush = (key: string, flush: (() => void) | null) => void;

const WizardSaveContext = createContext<RegisterFlush>(() => {});

export const WizardSaveProvider = WizardSaveContext.Provider;

export function useWizardSave(): RegisterFlush {
  return useContext(WizardSaveContext);
}
